import React from 'react';
import _ from 'lodash';

import {
  USER_ROLES,
  USER_VIEW_MODE,
  USER_STATUS,
  ZENDESK_URL_GUIDE,
} from '../utilities/constants';
import {
  isForemanRoleId,
  isTargetRoleId,
  isPrimaryCompanyRoleId,
  roleIdToJapaneseRoleName,
  isPartnerRoleId,
} from '../utilities/roleUtility';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { joinTel } from '../utilities/stringUtil';
import { messageUtility } from '../utilities/messageUtility';
import {
  FileInputForm,
  FormDropDownSingleSelect,
  FormDropDown,
} from './CommonFormComponents';
import * as Styles from '../styles/componentStyle/entrance/Users.scss';
import { FormList, FormListItem, FormElement } from './CommonFormComponents';
import { RadioButtonIcon } from './icons/RadioButtonIcon';
import Tippy from '../components/ReactTippy';
import {
  PartnerCompanyBranchDropdown,
  HEAD_OFFICE_OPTION,
} from './PartnerCompanyBranchDropdown';

/**
 * ユーザー詳細、編集、新規作成用のコンポーネント
 * */
export class UserForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      detailView: props.viewMode === USER_VIEW_MODE.DETAIL,
    };
    this.roleId = LocalStorageService.getRoleId();
    this.companyId = SessionStorageService.getCompanyId();
    this.partnerCompanyJoiningFlag = SessionStorageService.getPartnerCompanyJoiningFlag();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.viewMode !== this.props.viewMode) {
      this.setState({
        detailView: this.props.viewMode === USER_VIEW_MODE.DETAIL,
      });
    }
  }

  formUserForeman = () => {
    return (
      this.props.params.user_role_code &&
      !this.state.detailView &&
      isForemanRoleId(this.props.params.user_role_code)
    );
  };

  /**
   * 支店が固定されるべきかどうかを判定する
   *
   * @return {boolean} true:固定、false：選択可能
   * */
  shouldShitenFixed = () => {
    // 本社管理者を選択している場合は本社で固定
    if (isTargetRoleId([USER_ROLES.prime], this.props.params.user_role_code)) {
      return true;
    }

    // 支店管理者を選択している場合
    if (isTargetRoleId([USER_ROLES.branch], this.props.params.user_role_code)) {
      // 操作中のユーザーが元請けユーザーであれば変更可能、それ以外は固定
      return !isTargetRoleId([USER_ROLES.prime], this.roleId);
    }

    // 現場監督を選択している場合
    if (
      isTargetRoleId([USER_ROLES.manager], this.props.params.user_role_code)
    ) {
      // 操作中のユーザーが現場監督の場合は変更不可、それ以外は変更可能
      return isTargetRoleId([USER_ROLES.manager], this.roleId);
    }

    // 上記以外（協力会社管理者/職長）の場合は支店は選択できないため固定
    return true;
  };

  render() {
    return (
      <React.Fragment>
        <div className='contruction-slide-view__body contruction-slide-view__body--height-fix UserForm'>
          <div className='contruction-detail-view'>
            {this.props.sideView}
            <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
              <BackLinkButton
                events={this.props.events}
                viewMode={this.props.viewMode}
              />
              {/*
               *詳細画面の場合
               * */
              this.state.detailView && (
                <DetailHeaderMenu
                  hasBlockPermission={this.props.blockPermission}
                  blockFlag={this.props.params.block_flag}
                  blockUserName={this.props.params.block_user_name}
                  events={this.props.events}
                  userRoleCode={this.props.params.user_role_code}
                />
              )}
              {/*
               * 登録・編集画面の場合
               */
              !this.state.detailView && (
                <NewEditHeaderMenu
                  viewMode={this.props.viewMode}
                  hasError={!_.isEmpty(this.props.validationMessage)}
                  inputCount={this.props.inputCount}
                  requiredNumber={this.props.requiredNumber}
                  events={this.props.events}
                />
              )}

              <div className='contruction-detail-view__bar' />
              {/* ここからフォーム */}
              <div
                className={`${
                  Styles.users_main_slide
                } contruction-detail-view__main contruction-detail-view__main--fixed contruction-detail-view__main--fix set-width-dropdown`}
              >
                <FormList>
                  <BlockStatus value={this.props.params.block_flag} />
                  <UserType
                    value={this.props.params.user_role_code}
                    viewMode={this.props.viewMode}
                    isDetailView={this.state.detailView}
                    isPrimary={this.props.isPrimary}
                    events={this.props.events}
                    roleId={this.roleId}
                  />
                  <Permissions
                    value={this.props.params.buildee_manager_flg}
                    isManagerPermission={this.props.isManagerPermission}
                    hasManagerPermission={this.props.hasManagerPermission}
                    viewMode={this.props.viewMode}
                    isDetailView={this.state.detailView}
                    userRoleCode={this.props.params.user_role_code}
                    events={this.props.events}
                    roleId={this.roleId}
                  />
                  <ServicePermissions
                    value={this.props.params}
                    isManagerPermission={this.props.isManagerPermission}
                    viewMode={this.props.viewMode}
                    isDetailView={this.state.detailView}
                    events={this.props.events}
                    roleId={this.roleId}
                  />
                  {!_.isNull(this.props.params.user_role_code) &&
                    this.props.isPrimary && (
                      <Shiten
                        fixedFlag={this.shouldShitenFixed()}
                        fixedCompanyBranch={this.props.params.company_branch}
                        userRoleCode={this.props.params.user_role_code}
                        validationMessage={this.props.validationMessage}
                        defaultValue={this.props.params.company_branch}
                        events={this.props.events}
                        isDetailView={this.state.detailView}
                        keyName={'company_branch_id'}
                        roleId={this.roleId}
                      />
                    )}
                  {!this.props.isPrimary &&
                    (this.props.viewMode !== USER_VIEW_MODE.NEW ? (
                      <CompanyDropdown
                        userId={this.props.userId}
                        disabled={true}
                      />
                    ) : (
                      <CompanyBase />
                    ))}

                  {!!this.partnerCompanyJoiningFlag && (
                    <PartnerCompanyBranch
                      value={this.props.params.partner_company_branch}
                      selectedCompanyId={this.companyId}
                      viewMode={this.props.viewMode}
                      isManagerPermission={this.props.isManagerPermission}
                      roleId={this.roleId}
                      events={this.props.events}
                      previewValue={
                        _.get(
                          this.props.params.partner_company_branch,
                          'name'
                        ) || HEAD_OFFICE_OPTION.name
                      }
                    />
                  )}
                  <LastName
                    value={this.props.params.name_sei}
                    isDetailView={this.state.detailView}
                    events={this.props.events}
                    validationMessage={this.props.validationMessage}
                  />
                  <FirstName
                    value={this.props.params.name_mei}
                    isDetailView={this.state.detailView}
                    events={this.props.events}
                    validationMessage={this.props.validationMessage}
                  />
                  <LastNameKana
                    value={this.props.params.kana_sei}
                    isDetailView={this.state.detailView}
                    events={this.props.events}
                    validationMessage={this.props.validationMessage}
                  />
                  <FirstNameKana
                    value={this.props.params.kana_mei}
                    isDetailView={this.state.detailView}
                    events={this.props.events}
                    validationMessage={this.props.validationMessage}
                  />
                  <Tel
                    keyName={'tel'}
                    label='電話番号'
                    value={this.props.params.tel}
                    isDetailView={this.state.detailView}
                    events={this.props.events}
                    validationMessage={this.props.validationMessage}
                  />
                  {!this.props.isPrimary &&
                    this.props.params.user_role_code ===
                      USER_ROLES.partner.id && (
                      <Tel
                        keyName={'fax'}
                        label='FAX番号'
                        value={this.props.params.fax}
                        isDetailView={this.state.detailView}
                        events={this.props.events}
                        validationMessage={this.props.validationMessage}
                      />
                    )}
                  {!this.props.isPrimary &&
                  this.props.params.user_role_code === USER_ROLES.foreman.id &&
                  !this.props.params.integrated ? (
                    <React.Fragment>
                      <UserId
                        value={this.props.params.login_id}
                        isDetailView={this.state.detailView}
                        events={this.props.events}
                        validationMessage={this.props.validationMessage}
                        supplementalMessage={
                          !this.state.detailView
                            ? messageUtility.getMessage('I-001-252')
                            : null
                        }
                      />
                      <Email
                        value={this.props.params.email}
                        label='メールアドレス'
                        isDetailView={this.state.detailView}
                        events={this.props.events}
                        isNotRequired={true}
                        validationMessage={this.props.validationMessage}
                        isRecommended={this.formUserForeman()}
                        supplementalMessage={
                          this.formUserForeman() && !this.state.detailView
                            ? messageUtility.getMessage('I-001-418')
                            : null
                        }
                      />
                    </React.Fragment>
                  ) : (
                    <Email
                      value={this.props.params.email}
                      label='ユーザーID（メールアドレス）'
                      isDetailView={this.state.detailView}
                      events={this.props.events}
                      isNotRequired={false}
                      validationMessage={this.props.validationMessage}
                    />
                  )}
                  {!this.props.isPrimary &&
                    this.props.params.user_role_code ===
                      USER_ROLES.partner.id &&
                    this.props.viewMode !== USER_VIEW_MODE.NEW && (
                      <PasswordChange
                        password_reset_flg={
                          this.props.params.password_reset_notice_flag
                        }
                      />
                    )}
                  <Icon
                    value={this.props.params.image_url}
                    isDetailView={this.state.detailView}
                    events={this.props.events}
                    validationMessage={this.props.validationMessage}
                    info={this.props.photoInfo}
                  />
                </FormList>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

/**
 * リンク部分
 */
const BackLinkButton = props => {
  const getLabel = () => {
    return [USER_VIEW_MODE.DETAIL, USER_VIEW_MODE.NEW].includes(props.viewMode)
      ? '利用者一覧'
      : '利用者詳細';
  };

  return (
    <div className='contruction-detail-view__header'>
      <button className='btn-text--sm' onClick={props.events.back}>
        <i className='i-back--blue i-2x vertical-middle' />
        {getLabel()}
      </button>
    </div>
  );
};

/**
 *  詳細画面のヘッダー部のメニュー
 *
 * @param props
 */
const DetailHeaderMenu = props => {
  /**
   * 編集ボタンが押下可能か判定する
   * アカウントが停止中ではなく、職長以外のロールは「編集ボタン」を押下可能
   * @return {boolean} true：可能、false：不可能
   * */
  const editable = () => {
    if (props.blockFlag === 1) {
      return false;
    }
    if (_.isNil(props.userRoleCode)) {
      return false;
    }
    if (
      props.userRoleCode === USER_ROLES.prime.id &&
      isTargetRoleId([USER_ROLES.branch, USER_ROLES.manager], this.roleId)
    ) {
      // 対象のユーザーが本社管理者の場合、支店管理者と現場監督は編集不可
      return false;
    }
    if (
      props.userRoleCode === USER_ROLES.branch.id &&
      isTargetRoleId([USER_ROLES.manager], this.roleId)
    ) {
      // 対象のユーザーが支店管理者の場合、現場監督は編集不可
      return false;
    }
    // 職長は編集不可
    return !isTargetRoleId([USER_ROLES.foreman], this.roleId);
  };

  return (
    <div className='contruction-detail-view__menu'>
      {editable() ? (
        <span className='construction-detail-view__button'>
          <button className='btn' onClick={props.events.showEdit}>
            編集
          </button>
        </span>
      ) : null}
      {/* アカウント停止・復旧可能のユーザーにボタンを表示する */
      props.blockFlag === 0 && props.hasBlockPermission ? (
        <span className='construction-detail-view__button'>
          <button
            className='btn--negative'
            onClick={() => props.events.showConfirmBlockUnblock(true)}
          >
            アカウントの停止
          </button>
        </span>
      ) : props.blockFlag === 1 && props.hasBlockPermission ? (
        <span className='construction-detail-view__button'>
          <button
            className='btn--effective'
            onClick={() => props.events.showConfirmBlockUnblock(false)}
          >
            アカウントの復旧
          </button>
        </span>
      ) : null}
      {props.blockFlag === 1 && (
        <span className='blocked-user'>
          停止したユーザー：{props.blockUserName}
        </span>
      )}
      <div className='help-header'>
        <span className='help-text'>
          ユーザーの削除については
          <a
          className='clickable-text'
          href={ZENDESK_URL_GUIDE.DELETE_USER}
          target='_blank'
          rel='noreferrer noopener'
          >
            こちら
          </a>
          をご確認ください。<br/>
          </span>
            {/* 協力会社管理者の場合のみ、職長パスワードリセット通知先の注釈を表示する */
            isPartnerRoleId(props.roleId) &&(
            <span className='help-text'>
              ※職長パスワードリセット通知先に設定されていてもアカウント停止されている場合にはメールが送信されません。
            </span>
            )}
      </div>
    </div>
  );
};

/**
 * 編集画面のヘッダーメニュー
 *
 * @param props
 * */
const NewEditHeaderMenu = props => {
  return (
    <div className='contruction-detail-view__menu'>
      {props.viewMode === USER_VIEW_MODE.EDIT && (
        <span className='construction-detail-view__button'>
          <button className='btn--negative' onClick={props.events.back}>
            編集をやめる
          </button>
        </span>
      )}
      {props.viewMode === USER_VIEW_MODE.NEW ? (
        <span className='construction-detail-view__button'>
          <button className='btn--effective' onClick={props.events.submit}>
            登録
          </button>
        </span>
      ) : (
        <React.Fragment>
          <span className='construction-detail-view__button'>
            <button className='btn--effective' onClick={props.events.submit}>
              更新
            </button>
          </span>
          <span className='help-text'>
            ユーザーの削除については
            <a
              className='clickable-text'
              href={ZENDESK_URL_GUIDE.DELETE_USER}
              target='_blank'
              rel='noreferrer noopener'
            >
              こちら
            </a>
            をご確認ください。
          </span>
        </React.Fragment>
      )}
      <div
        className={`${
          Styles.users_main_slide
        } contruction-detail-view__end-item`}
        style={{ display: 'flex' }}
      >
        {props.hasError && (
          <div className='has-error'>入力エラーがあります。</div>
        )}
        {`必須項目の入力数 ${props.inputCount}/${props.requiredNumber}`}
      </div>
    </div>
  );
};

/**
 * ステータス
 * */
const BlockStatus = props => {
  // APIロードが終わってから表示する
  if (!props.value) {
    return null;
  }
  if (props.value === USER_STATUS.stop.id) {
    return (
      <FormListItem label={'ステータス'}>
        <FormElement>{USER_STATUS.stop.name}</FormElement>
      </FormListItem>
    );
  }
};

/**
 * 支店
 * */
const PartnerCompanyBranch = ({
  selectedCompanyId,
  value,
  events,
  viewMode,
  isManagerPermission,
  roleId,
}) => {
  const isNewView = viewMode === USER_VIEW_MODE.NEW;

  if (
    !isTargetRoleId([USER_ROLES.partner, USER_ROLES.foreman], roleId) ||
    (isNewView && !isManagerPermission)
  ) {
    return null;
  }

  const isDetailView = viewMode === USER_VIEW_MODE.DETAIL;
  const { id, name } = value || {};

  return (
    <FormListItem label='支店' required={!isDetailView && isManagerPermission}>
      <FormElement info='支店のデフォルトは本社となります。支店の登録、支店への配属は企業管理者のみが実行できます。'>
        <PartnerCompanyBranchDropdown
          selectedCompanyId={selectedCompanyId}
          selectedPartnerCompanyBranchId={id || HEAD_OFFICE_OPTION.id}
          onSelect={id => {
            events.onChange('partner_company_branch', { id });
          }}
          previewValue={name}
          disabled={isDetailView || !isManagerPermission}
          fixedOptions={[HEAD_OFFICE_OPTION]}
        />
      </FormElement>
    </FormListItem>
  );
};

/**
 * ユーザー種別
 * */
const UserType = props => {
  // APIロードが終わってから表示する
  if (!props.value) {
    return null;
  }
  // ユーザーが操作できない時はradioを表示しない
  const ReadOnlyUserType = () => {
    return (
      <FormListItem label={'ユーザー種別'}>
        <FormElement>{roleIdToJapaneseRoleName(props.value)}</FormElement>
      </FormListItem>
    );
  };

  // 詳細画面
  if (props.isDetailView) {
    return <ReadOnlyUserType />;
  }

  // 編集画面 元請権限かつ現場監督時
  if (
    props.viewMode === USER_VIEW_MODE.EDIT &&
    props.isPrimary &&
    isTargetRoleId([USER_ROLES.manager], this.roleId)
  ) {
    return <ReadOnlyUserType />;
  }

  // 編集画面 協力会社権限
  if (props.viewMode === USER_VIEW_MODE.EDIT && !props.isPrimary) {
    return <ReadOnlyUserType />;
  }
  return (
    <FormListItem label={'ユーザー種別'} required={!props.isDetailView}>
      {props.isPrimary ? (
        <FormElement>
          <div className='form-list-radio'>
            {isTargetRoleId([USER_ROLES.prime], props.roleId) && (
              <div className='form-list-radio__item'>
                <label className={`radio`}>
                  <input
                    type='radio'
                    checked={props.value === USER_ROLES.prime.id}
                    disabled={props.isDetailView}
                    onChange={() => {
                      props.events.onChange(
                        'user_role_code',
                        USER_ROLES.prime.id
                      );
                    }}
                  />
                  <RadioButtonIcon className='icon--2x' />
                  <span>{USER_ROLES.prime.name}</span>
                </label>
              </div>
            )}
            {isTargetRoleId(
              [USER_ROLES.prime, USER_ROLES.branch],
              props.roleId
            ) && (
              <div className='form-list-radio__item'>
                <label className={`radio`}>
                  <input
                    type='radio'
                    disabled={props.isDetailView}
                    checked={props.value === USER_ROLES.branch.id}
                    onChange={() => {
                      props.events.onChange(
                        'user_role_code',
                        USER_ROLES.branch.id
                      );
                    }}
                  />
                  <RadioButtonIcon className='icon--2x' />
                  <span>{USER_ROLES.branch.name}</span>
                </label>
              </div>
            )}
            {isTargetRoleId(
              [USER_ROLES.prime, USER_ROLES.branch, USER_ROLES.manager],
              props.roleId
            ) && (
              <React.Fragment>
                {// 現場監督は選択肢が1つなのでradioは表示しない
                isTargetRoleId([USER_ROLES.manager], props.roleId) ? (
                  <span>{USER_ROLES.manager.name}</span>
                ) : (
                  <div className='form-list-radio__item'>
                    <label className={`radio`}>
                      <input
                        type='radio'
                        disabled={props.isDetailView}
                        checked={props.value === USER_ROLES.manager.id}
                        onChange={() => {
                          props.events.onChange(
                            'user_role_code',
                            USER_ROLES.manager.id
                          );
                        }}
                      />
                      <RadioButtonIcon className='icon--2x' />
                      <span>{USER_ROLES.manager.name}</span>
                    </label>
                  </div>
                )}
              </React.Fragment>
            )}
          </div>
        </FormElement>
      ) : (
        <FormElement>
          <div className='form-list-radio'>
            <div className='form-list-radio__item'>
              <label className={`radio`}>
                <input
                  type='radio'
                  disabled={props.viewMode !== USER_VIEW_MODE.NEW}
                  checked={props.value === USER_ROLES.partner.id}
                  onChange={() => {
                    props.events.onChange(
                      'user_role_code',
                      USER_ROLES.partner.id
                    );
                  }}
                />
                <RadioButtonIcon className='icon--2x' />
                <span>{USER_ROLES.partner.name}</span>
              </label>
            </div>
            <div className='form-list-radio__item'>
              <label className={`radio`}>
                <input
                  type='radio'
                  disabled={props.viewMode !== USER_VIEW_MODE.NEW}
                  checked={props.value === USER_ROLES.foreman.id}
                  onChange={() => {
                    props.events.onChange(
                      'user_role_code',
                      USER_ROLES.foreman.id
                    );
                  }}
                />
                <RadioButtonIcon className='icon--2x' />
                <span>{USER_ROLES.foreman.name}</span>
              </label>
            </div>
          </div>
        </FormElement>
      )}
    </FormListItem>
  );
};

/**
 * 権限
 * */
const Permissions = props => {
  const Question = props => {
    return (
      <div className={`${Styles.question_tooltip}`}>
        <Tippy
          duration={10}
          distance={24}
          arrow='true'
          arrowType='sharp'
          delay={[100, 100]}
          placement='top'
          followCursor={true}
          html={<div className='permission-tooltip'>{props.message}</div>}
        >
          <i className='i-question--tooltip i-question--grey' />
        </Tippy>
      </div>
    );
  };
  let questionMessage = '';
  if (isTargetRoleId([USER_ROLES.manager, USER_ROLES.foreman], props.roleId)) {
    questionMessage = messageUtility.getMessage(
      'I-000-126',
      roleIdToJapaneseRoleName(props.roleId)
    );
  } else if (!props.isManagerPermission) {
    if (!props.hasManagerPermission) {
      questionMessage = messageUtility.getMessage('I-000-127');
    } else {
      questionMessage = messageUtility.getMessage('I-000-125');
    }
  } else {
    if (isPrimaryCompanyRoleId(props.roleId)) {
      questionMessage = messageUtility.getMessage(
        'I-000-124',
        '本社管理者または支店管理者'
      );
    } else {
      questionMessage = messageUtility.getMessage(
        'I-000-124',
        '協力会社管理者'
      );
    }
  }
  return (
    <FormListItem label={'権限'}>
      <FormElement
        info={
          !props.isDetailView &&
          props.isManagerPermission &&
          props.viewMode === USER_VIEW_MODE.NEW &&
          isTargetRoleId([USER_ROLES.partner], props.roleId) &&
          !(
            props.userRoleCode &&
            isTargetRoleId([USER_ROLES.foreman], props.userRoleCode)
          ) && (
            <span>
              ※ユーザーによる招待内容の確認後に、編集画面から企業管理者に設定できます。
            </span>
          )
        }
      >
        <div className='flex-column'>
          <div className='flex flex-row'>
            {!props.value ||
            (!props.isDetailView &&
              props.userRoleCode &&
              isTargetRoleId(
                [USER_ROLES.manager, USER_ROLES.foreman],
                props.userRoleCode
              ))
              ? 'このユーザーは一般ユーザーです'
              : 'このユーザーは企業管理者です'}
            {/* <Question message={questionMessage} /> */}
          </div>
          {!props.isDetailView &&
            props.isManagerPermission &&
            !(
              isTargetRoleId(
                [USER_ROLES.partner, USER_ROLES.foreman],
                props.roleId
              ) && props.viewMode === USER_VIEW_MODE.NEW
            ) &&
            !(
              isTargetRoleId(
                [USER_ROLES.manager, USER_ROLES.foreman],
                props.roleId
              ) ||
              (props.userRoleCode &&
                isTargetRoleId(
                  [USER_ROLES.manager, USER_ROLES.foreman],
                  props.userRoleCode
                ))
            ) && (
              <div className='form-container__item'>
                <label className='checkbox'>
                  <input
                    type='checkbox'
                    checked={props.value}
                    disabled={!props.isManagerPermission}
                    onChange={e => {
                      props.events.onChange(
                        'buildee_manager_flg',
                        e.target.checked
                      );
                    }}
                  />
                  <i className='i-square i-3x' aria-hidden='true' />
                  <span>権限を昇格させる（企業管理者になります）</span>
                </label>
              </div>
            )}
        </div>
      </FormElement>
    </FormListItem>
  );
};

/**
 * サービス権限
 * */
const ServicePermissions = props => {
  return (
    <FormListItem label={'サービス権限'}>
      <FormElement
        info={
          !props.isDetailView &&
          props.isManagerPermission && (
            <span className='bold'>
              ※本設定により料金が発生することはありません。
            </span>
          )
        }
      >
        <div className='flex-column'>
          <div className='flex flex-row'>
            {!(
              (props.isDetailView || !props.isManagerPermission) &&
              (!props.value ||
                !props.value.use_chosei_flg ||
                !props.value.use_nyutaijo_flg)
            ) && (
              <label className='checkbox'>
                {!props.isDetailView && props.isManagerPermission && (
                  <React.Fragment>
                    <input
                      type='checkbox'
                      checked={
                        props.value &&
                        props.value.use_chosei_flg &&
                        props.value.use_nyutaijo_flg
                      }
                      onChange={e => {
                        let permissions = { ...props.value };
                        permissions.use_chosei_flg = e.target.checked;
                        permissions.use_nyutaijo_flg = e.target.checked;
                        props.events.onChange('permissions', permissions);
                      }}
                    />
                    <i className='i-square i-3x' aria-hidden='true' />
                  </React.Fragment>
                )}
                <span className='form-list__item-text'>
                  調整会議・入退場管理
                </span>
              </label>
            )}
            {!(
              (props.isDetailView || !props.isManagerPermission) &&
              (!props.value || !props.value.use_green_file_flg)
            ) && (
              <label className='checkbox'>
                {!props.isDetailView && props.isManagerPermission && (
                  <React.Fragment>
                    <input
                      type='checkbox'
                      checked={props.value && props.value.use_green_file_flg}
                      onChange={e => {
                        let permissions = { ...props.value };
                        permissions.use_green_file_flg = e.target.checked;
                        props.events.onChange('permissions', permissions);
                      }}
                    />
                    <i className='i-square i-3x' aria-hidden='true' />
                  </React.Fragment>
                )}
                <span className='form-list__item-text'>労務安全</span>
              </label>
            )}
          </div>
        </div>
      </FormElement>
    </FormListItem>
  );
};

/** 姓 */
const LastName = props => {
  return (
    <TextInput
      label={'姓'}
      keyName={'name_sei'}
      validationMessage={props.validationMessage}
      placeholder={'（例）山田'}
      maxLength={'64'}
      events={props.events}
      value={props.value}
      isDetailView={props.isDetailView}
    />
  );
};

/** 名 */
const FirstName = props => {
  return (
    <TextInput
      label={'名'}
      keyName={'name_mei'}
      validationMessage={props.validationMessage}
      placeholder={'（例）太郎'}
      maxLength={'64'}
      events={props.events}
      value={props.value}
      isDetailView={props.isDetailView}
    />
  );
};

/** せい */
const LastNameKana = props => {
  return (
    <TextInput
      label={'せい'}
      keyName={'kana_sei'}
      validationMessage={props.validationMessage}
      placeholder={'（例）やまだ'}
      maxLength={'128'}
      events={props.events}
      value={props.value}
      isDetailView={props.isDetailView}
    />
  );
};

/** めい */
const FirstNameKana = props => {
  return (
    <TextInput
      label={'めい'}
      keyName={'kana_mei'}
      validationMessage={props.validationMessage}
      placeholder={'（例）たろう'}
      maxLength={'128'}
      events={props.events}
      value={props.value}
      isDetailView={props.isDetailView}
    />
  );
};

const Email = props => {
  return (
    <TextInput
      label={props.label}
      disabled={props.isDetailView}
      keyName={'email'}
      validationMessage={props.validationMessage}
      placeholder={'メールアドレスを入力'}
      maxLength={'255'}
      events={props.events}
      value={props.value}
      isDetailView={props.isDetailView}
      isNotRequired={props.isNotRequired}
      isRecommended={props.isRecommended}
      supplementalMessage={props.supplementalMessage}
    />
  );
};

const UserId = props => {
  return (
    <React.Fragment>
      <TextInput
        label={'ユーザーID'}
        keyName={'login_id'}
        validationMessage={props.validationMessage}
        placeholder={'ユーザーIDを入力'}
        maxLength={'60'}
        events={props.events}
        value={props.value}
        isDetailView={props.isDetailView}
        supplementalMessage={props.supplementalMessage}
      />
    </React.Fragment>
  );
};

const TextInput = props => {
  let validationMessage = ``;
  if (props.validationMessage) {
    validationMessage = props.validationMessage[props.keyName];
    if (validationMessage && customValidationMessage[props.keyName]) {
      validationMessage = customValidationMessage[props.keyName];
    }
  }
  let value = '';
  if (!_.isEmpty(props.value)) {
    value = props.value;
  }

  const className = props.keyName === 'email' ? 'form-list__input-large' : '';

  const infoMessage =
    !props.isDetailView && props.keyName === 'login_id'
      ? messageUtility.getMessage('I-001-252')
      : '';

  return (
    <FormListItem
      label={props.label}
      required={!props.isDetailView && props.isNotRequired !== true}
      isRecommended={props.isRecommended}
    >
      <FormElement
        validate={validationMessage}
        info={
          props.supplementalMessage ? props.supplementalMessage : infoMessage
        }
      >
        <input
          type='text'
          className={className}
          value={value}
          disabled={props.isDetailView}
          placeholder={props.isDetailView === true ? '' : props.placeholder}
          maxLength={props.maxLength}
          onChange={e => {
            props.events.onChange(props.keyName, e.target.value);
          }}
          onBlur={e => {
            if (!props.isDetailView) {
              props.events.onBlur(props.keyName, e.target.value);
            }
          }}
        />
      </FormElement>
    </FormListItem>
  );
};

const Tel = props => {
  let validationMessage = ``;
  if (props.validationMessage) {
    validationMessage = props.validationMessage[props.keyName];
  }
  let tel1 = '';
  let tel2 = '';
  let tel3 = '';
  if (props.value && props.value !== 'undefined') {
    const tel = props.value.split('-');
    if (tel.length > 0) {
      tel1 = tel[0];
      tel2 = tel[1];
      tel3 = tel[2];
    }
  }

  // 詳細かつ電話番号が設定されていない時、--は表示しない
  if (props.isDetailView) {
    if (tel1 === '' && tel2 === '' && tel3 === '') {
      return (
        <FormListItem label={props.label}>
          <FormElement />
        </FormListItem>
      );
    }
  }

  return (
    <FormListItem label={props.label}>
      <FormElement validate={validationMessage}>
        <label htmlFor={props.keyName} className='input-tel'>
          <input
            type={'text'}
            placeholder={props.isDetailView === true ? '' : '03'}
            maxLength={'5'}
            disabled={props.isDetailView}
            defaultValue={tel1}
            value={tel1}
            onChange={e => {
              props.events.onChange(
                props.keyName,
                joinTel(e.target.value, tel2, tel3)
              );
            }}
            onBlur={e => {
              if (!props.isDetailView) {
                props.events.onBlur(
                  props.keyName,
                  joinTel(e.target.value, tel2, tel3)
                );
              }
            }}
          />
          -
          <input
            type={'text'}
            placeholder={props.isDetailView === true ? '' : '1234'}
            maxLength={'4'}
            disabled={props.isDetailView}
            defaultValue={tel2}
            value={tel2}
            onChange={e => {
              props.events.onChange(
                props.keyName,
                joinTel(tel1, e.target.value, tel3)
              );
            }}
            onBlur={e => {
              if (!props.isDetailView) {
                props.events.onBlur(
                  props.keyName,
                  joinTel(tel1, e.target.value, tel3)
                );
              }
            }}
          />
          -
          <input
            type={'text'}
            placeholder={props.isDetailView === true ? '' : '5678'}
            maxLength={'4'}
            disabled={props.isDetailView}
            defaultValue={tel3}
            value={tel3}
            onChange={e => {
              props.events.onChange(
                props.keyName,
                joinTel(tel1, tel2, e.target.value)
              );
            }}
            onBlur={e => {
              if (!props.isDetailView) {
                props.events.onBlur(
                  props.keyName,
                  joinTel(tel1, tel2, e.target.value)
                );
              }
            }}
          />
        </label>
      </FormElement>
    </FormListItem>
  );
};

const Shiten = props => {
  let validationMessage = ``;
  if (props.validationMessage) {
    validationMessage = props.validationMessage[props.keyName];
    if (validationMessage && customValidationMessage[props.keyName]) {
      validationMessage = customValidationMessage[props.keyName];
    }
  }
  const getDropDownSelect = () => {
    if (props.fixedFlag) {
      return (
        <FormElement>
          {isTargetRoleId([USER_ROLES.prime], props.userRoleCode) ? (
            '本社'
          ) : (
            <React.Fragment>
              {!_.isNil(props.fixedCompanyBranch)
                ? _.defaultTo(props.fixedCompanyBranch.name, '　')
                : '　'}
            </React.Fragment>
          )}
        </FormElement>
      );
    } else {
      // ユーザーが操作できない時は文字列で出力
      if (props.isDetailView && _.has(props, 'defaultValue.name')) {
        return <FormElement>{props.defaultValue.name}</FormElement>;
      }
      return (
        <FormElement validate={validationMessage}>
          <FormDropDownSingleSelect
            className='shiten'
            disabled={props.isDetailView}
            label='支店を指定'
            placeholder='支店名を選択'
            apiPath='/api/private/company_branches/list'
            entitiesKey='company_branches'
            defaultValue={props.defaultValue}
            callback={value => {
              props.events.onChange('company_branch', value);
            }}
          />
        </FormElement>
      );
    }
  };

  /**
   * 支店に必須マークが必要かどうかを判定する
   *
   * @return {boolean} true:必要、false:不要
   * */
  const isRequired = () => {
    if (props.isDetailView) {
      // 詳細画面の場合は不要
      return false;
    }
    if (isTargetRoleId([USER_ROLES.prime], props.userRoleCode)) {
      // ユーザー種別が本社管理者の場合は本社固定のため不要
      return false;
    }

    if (isTargetRoleId([USER_ROLES.branch], props.userRoleCode)) {
      // ユーザー種別が支店管理者の場合は、操作ユーザーが本社管理者の場合は必要、それ以外は不要
      return isTargetRoleId([USER_ROLES.prime], props.roleId);
    }

    if (isTargetRoleId([USER_ROLES.manager], props.userRoleCode)) {
      // ユーザー種別が現場管理者の場合は、操作ユーザーが現場管理者以外は必要、それ以外は不要
      return !isTargetRoleId([USER_ROLES.manager], props.roleId);
    }

    // 上記パターン以外は支店は固定のため不要
    return false;
  };

  return (
    <FormListItem label='支店' required={isRequired()}>
      {getDropDownSelect()}
    </FormListItem>
  );
};

/**
 * @description 「元請会社／協力会社」(ビュー専用ドロップダウン版の共通のView)
 *
 * 元請会社／協力会社の追加、編集はユーザー新規登録、編集画面ではできない
 *
 */
const CompanyDropdown = props => (
  <FormListItem label={messageUtility.getMessage('I-001-011')}>
    <FormElement className='form-list__element form-list__element--dropdown'>
      {/* ビュー専用 */}
      <FormDropDown
        apiPath={`/api/private/users/${props.userId}/prime_list`}
        // 表示に使う返却値のキー
        itemKey='display'
        entitiesKey='company'
        disabled={props.disabled}
        params={props.params}
        readOnly
      />
    </FormElement>
  </FormListItem>
);

/**
 * @description 新規利用者登録画面(協力会社)の「元請会社／協力会社」選択コンポーネント
 *
 * 元請会社／協力会社の追加、編集はユーザー新規登録、編集画面ではできない
 *
 */
export const CompanyBase = () => (
  <FormListItem label={messageUtility.getMessage('I-001-011')}>
    <FormElement>
      {/* DropDownのコンポーネントだがisReadOnlyでラベル表示 */}
      {/* API呼び出してリストから選択する処理は必要なのでDropDownのコンポーネントを使用 */}
      <FormDropDownSingleSelect
        isReadOnly={true}
        apiPath='/api/private/company_branches/prime_list'
        // 表示に使う返却値のキー
        itemKey='display'
        entitiesKey='company'
        params={{
          company_id: SessionStorageService.getItem(
            'sessionPartnerCompanyIdOfPrimeCompany'
          ),
        }}
        selectedIdType='partner_company_id'
        selectedValue={SessionStorageService.getItem(
          'sessionPartnerCompanyIdOfPrimeCompany'
        )}
      />
    </FormElement>
  </FormListItem>
);

/**
 * @description 職長パスワードリセット通知先
 */
const PasswordChange = props => {
  return (
    <FormListItem label='職長パスワードリセット通知先'>
      {props.password_reset_flg ? (
        <FormElement>通知先に設定されています</FormElement>
      ) : null}
    </FormListItem>
  );
};

const Icon = props => {
  return (
    <FormListItem label='アイコン画像'>
      <FileInputForm
        value={props.value}
        onUpdate={value => {
          props.events.onChange('image_url', value);
        }}
        disabled={props.isDetailView}
        validate={
          props.validationMessage
            ? props.validationMessage['image_url']
              ? props.validationMessage['image_url']
              : props.validationMessage
            : null
        }
        info={props.info}
      />
    </FormListItem>
  );
};

const customValidationMessage = {
  name_sei: '必須です。64文字以下で入力してください',
  name_mei: '必須です。64文字以下で入力してください',
  kana_sei: '必須です。ひらがなで128文字以下で入力してください',
  kana_mei: '必須です。ひらがなで128文字以下で入力してください',
};

UserForm.defaultProps = {
  hasBlockPermission: false,
};



// WEBPACK FOOTER //
// ./src/components/UserForm.jsx